{
  "close": "Close",
  "sidebar": {
    "toggle": "Toggle Sidebar",
    "title": "Sidebar",
    "description": "Displays the mobile sidebar."
  }
}
